import { JsonProperty } from "../../../models/utilities/json-property";
import { ShipmentStatus } from "../../../transportation/models/enums/shipment-status";
import { UnplannedMetric } from "./unplanned-task-metric";

export class UnplannedDeliveryMetricsGroupDto {

    public shipmentId : number = 0;

    public shipmentName : string = '';

    public shipmentStatus : ShipmentStatus = ShipmentStatus.Cancelled;
    
    @JsonProperty({ toType: 'datetime-specific' })
    public departureTimeLocal : Date|undefined = undefined;

    @JsonProperty({  toClass: UnplannedMetric, designType: 'array' })
    public metrics : UnplannedMetric[] = [];

}
